import styled from "styled-components";

const Uhr = styled.img`
  position: absolute;
  bottom: 2%;
  left: 2%;
`;

const TimeText = styled.strong`
  position: absolute;
  bottom: 1.8%;
  left: 5.8%;
`;

export default ({time}: {time: number}) => {
    return <>
    <Uhr width={15} height={15} src="/uhr.png"/>
    <TimeText>{Math.ceil(time / 1000)}</TimeText>
    </>
}